import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class ViewContainer extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
  }

  componentDidMount() {
    const nodeAppearCheck = (node) => {
      if (node) {
        const nodeRect = node.getBoundingClientRect();
        const nodeOffsetTop = nodeRect.top + window.pageYOffset;
        const windowScrollBottom =
          window.pageYOffset + document.documentElement.clientHeight - nodeRect.height;

        if (windowScrollBottom >= nodeOffsetTop) {
          return true;
        }
      }
      return false;
    };
    // ===
    const node = (this.node || {}).current || null;
    // ===
    const crossSaleAppearListener = () => {
      const { onView } = this.props;
      if (nodeAppearCheck(node)) {
        if (onView) {
          onView();
        }
        window.removeEventListener('scroll', crossSaleAppearListener);
      }
    };

    window.addEventListener('scroll', crossSaleAppearListener);
  }

  render() {
    const { children, className } = this.props;
    return (
      <div className={className} ref={this.node}>
        {children}
      </div>
    );
  }
}

ViewContainer.propTypes = {
  onView: PropTypes.func,
  children: PropTypes.any,
  className: PropTypes.string,
};
